import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CategoriaClienteRepository } from 'src/app/domain/service/categoria-cliente/categoria-cliente-repository';
import { CategoriaCliente } from '@model/categoria-cliente/categoria-cliente';

/**
 * Adaptador HTTP: HttpCategoriaClienteRepository
 *
 * Implementa el puerto CategoriaClienteRepository para comunicación HTTP con backend.
 * Realiza llamadas REST al backend Spring Boot (CategoriaClienteController).
 *
 * Arquitectura Hexagonal:
 * - Este adaptador está en infraestructura
 * - Implementa el puerto CategoriaClienteRepository del dominio
 *
 * Backend: 580-girop_servicios-ms (puerto 8080)
 *
 * @author Sura - Migración GWT a Spring Boot
 */
@Injectable({ providedIn: 'root' })
export class HttpCategoriaClienteRepository implements CategoriaClienteRepository {

  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.backend.baseUrl}/servicios/categorias-cliente`;

  async obtenerCategoriasCliente(nmconsecutivoCliente: number): Promise<CategoriaCliente[]> {
    const params = new HttpParams().set('nmconsecutivoCliente', nmconsecutivoCliente.toString());
    return firstValueFrom(
      this.http.get<CategoriaCliente[]>(this.baseUrl, { params })
    );
  }
}
